export const LIMITED = 1;
export const UNLIMITED = -1;
export const QUARTERLY = 4;
export const ANNUALLY = 1;
export const LOWER_LEARNER_LIMIT = 5;
export const UPPER_LEARNER_LIMIT = 125;
export const MIN_LICENSE_COUNT = 5;
export const MAX_LICENSE_COUNT = 125;

export const DISCRETIONARY_DISCOUNTED_LEARNER_LIMIT = 30;

export const billingTypes = {
  ONE_TIME: 'ONE_TIME',
  QUARTERLY: 'QUARTERLY',
} as const;

export type BillingTypeValues = (typeof billingTypes)[keyof typeof billingTypes];
